import { render } from "./PorttView.vue?vue&type=template&id=6ab86a18"
import script from "./PorttView.vue?vue&type=script&lang=js"
export * from "./PorttView.vue?vue&type=script&lang=js"

import "./PorttView.vue?vue&type=style&index=0&id=6ab86a18&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__